// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xyHB","title":"Info_title__11N8D","links":"Info_links__3cghd","link":"Info_link__-KwHq","logo":"Info_logo__1i-QH"};